import { User, Building2, ChevronRight } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';

export type LibraryArchiveScope = 'user' | 'agency';

interface LibraryArchiveSelectorProps {
  onSelect: (scope: LibraryArchiveScope) => void;
}

/**
 * Step iniziale mostrato in `LibraryPage` a chi ha un'agenzia (account `agency` stesso,
 * o `travel_advisor_member` con `agency_id`): fa scegliere se navigare la libreria
 * personale o quella dell'agenzia, prima di mostrare i tab per tipo attività.
 * Stile coerente con le altre scelte "a bottone" del builder (es.
 * ActivitySourceChoiceModal, AccommodationChoiceModal), ma qui è una vista a pagina
 * intera e non un modal.
 */
export function LibraryArchiveSelector({ onSelect }: LibraryArchiveSelectorProps) {
  const { t } = useI18n();

  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div className="text-center">
        <h2 className="text-lg font-semibold text-gray-900">{t('library.archiveChoiceTitle')}</h2>
      </div>

      <div className="flex flex-col gap-3">
        <button
          type="button"
          onClick={() => onSelect('user')}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 text-left w-full transition-colors hover:bg-gray-50"
        >
          <User className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('library.archiveChoicePersonalAction')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('library.archiveChoicePersonalDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>

        <button
          type="button"
          onClick={() => onSelect('agency')}
          className="flex items-center gap-4 p-4 rounded-xl border border-gray-200 text-left w-full transition-colors hover:bg-gray-50"
        >
          <Building2 className="h-5 w-5 text-gray-700 flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-gray-900">{t('library.archiveChoiceAgencyAction')}</p>
            <p className="text-sm text-gray-500 mt-0.5">{t('library.archiveChoiceAgencyDescription')}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 flex-shrink-0" />
        </button>
      </div>
    </div>
  );
}
